import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseModel, Country } from '../models';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BaseApiClient {
  basePath: string = '';

  private readonly _http = inject(HttpClient);

  getByName(name: string): Observable<any> {
    return this._http.get(`${this.basePath}/by-name?${new URLSearchParams({ name })}`);
  }

  getListOptions(parentId?: number): Observable<Country[]> {
    return this._http.get<Country[]>(`${this.basePath}/list-options${parentId ? `/${parentId}` : ''}`);
  }

  search(term: string, parentId: number, returnAll: boolean = false): Observable<BaseModel[]> {
    const url = `${this.basePath}/search?term=${term}  ${parentId ? `&parentId=${parentId}` : ''} &returnAll=${returnAll}`;
    return this._http.get<BaseModel[]>(url);
  }
}
